<template lang="pug">
#app(
  :class="{ 'is-ios': isIos && isStandalone, 'is-ios-safari': isIos && !isStandalone, 'gradient-bg': shouldDisplayGradient }"
)
  sign-out-info(v-if="(this.$route.path == '/delivery' || this.$route.path == '/lockers') && this.$isMbank")
  transition(:name="getCurrentRouteAnimation()")
    router-view
  toasts-container
  navigation-bar(v-show="isNavVisible")
  menu-container
  onboarding-screen(v-if="showOnboarding && !$isTvn && !$isZabka" @hideOnboarding="hideOnboardingHandler")
  modal-root
  version
</template>

<script>
import ToastsContainer from '@/vcs/_shared/toasts-container/cmp.vue'
import MenuContainer from '@/vcs/_shared/menu-container/cmp.vue'
import ModalRoot from '@/vcs/_shared/modal-root/cmp.vue'
import NavigationBar from '@/vcs/_shared/navigation-bar/cmp.vue'
import SignOutInfo from '@/vcs/_shared/sign-out-info/cmp.vue'

import IsStandalone from '@/mixins/is-standalone.js'
import IsIos from '@/mixins/is-ios.js'
import IsSafariDesktop from '@/mixins/is-safari-desktop.js'
import IsSafariIos from '@/mixins/is-safari-ios.js'
import IsChromeDesktop from '@/mixins/is-chrome-desktop.js'
import IsChromeAndroid from '@/mixins/is-chrome-android.js'
import IsFirefoxDesktop from '@/mixins/is-firefox-desktop.js'

import UpdateUserActivity from '@/mixins/update-user-activity.js'
import IsFcmEnabled from '@/mixins/is-fcm-enabled.js'
import StartFlowAPN from '@/mixins/start-flow-apn.js'

import DetectLocale from '@/mixins/detect-locale.js'
import RouterHooks from '@/mixins/router-hooks.js'
import baseStore from '@/stores/Store.js'
import toastStore from '@/stores/toast-store.js'
// import PushNotificationFlow from '@/mixins/push-notification-flow.js';
import { EventBus } from './event-bus.js'
import ShowAddAppToHomeScreenModal from '@/vcs/_shared/modals/add-to-homescreen-modal/cmp.vue'
import iOSAddToHomeScreenPromptModal from '@/vcs/_shared/modals/iOS-add-to-home-screen-prompt-modal/cmp.vue'

// PushNotificationModals
import NotificationPromptModalForChromeAndroidDesktop from '@/vcs/_shared/modals/push-notification-modals/notification-prompt-modal-for-chrome-android-desktop/cmp.vue'

export default {
  mixins: [
    IsStandalone,
    IsIos,
    IsSafariDesktop,
    IsSafariIos,
    IsChromeDesktop,
    IsChromeAndroid,
    IsFirefoxDesktop,
    UpdateUserActivity,
    DetectLocale,
    RouterHooks,
    // PushNotificationFlow,
    IsFcmEnabled,
    StartFlowAPN,
  ],
  data: function () {
    return {
      deferredPrompt: null,
      showInstallButton: false,
      showOnboarding: false,
    }
  },
  computed: {
    isNavVisible() {
      return !this.$route.meta || !this.$route.meta.auth
    },
    shouldDisplayGradient() {
      return this.$route.meta && this.$route.meta.auth
    },
  },
  mounted() {
    // Stash the event so it can be triggered later.
    window.addEventListener('beforeinstallprompt', e => {
      e.preventDefault()
      window.deferredPrompt = e
    })
    window.addEventListener('online', this.handleConnection)
    window.addEventListener('offline', this.handleConnection)
    document.addEventListener('visibilitychange', this.checkVisibility)

    EventBus.$on('clearBeforeinstallprompt', this.clearBeforeinstallprompt)
    if (!this.$isZabka) {
      EventBus.$on('showOnboardingAndModalsWhenLogin', this.showOnboardingAndModalsWhenLogin)
    }
  },
  created() {
    this.determineLocales()
  },
  methods: {
    clearBeforeinstallprompt() {
      // Clearing beforeinstallprompt event
      // Zaraz po tym jak funkcja `addToHomeScreen` doda appke do ekranu glownego odpali się `appinstalled` event i wy-nulluje zmienną `window.deferredPrompt`. Pokazuje on ze appka sie zainstalowala.

      // Niestety po nim znowu odpali sie `beforeinstallprompt` event i wypełni zmienną `window.deferredPrompt`, wiec, w funkcji `clearBeforeinstallprompt` będziemy wykonywac instrukcję ktora wyczyści tą zmienną. Instrukcja wykonywana jest w timeoucie poniewaz chcemy miec pewnosc ze `beforeinstallprompt` ponownie sie odpali zeby je nadpisac.

      setTimeout(() => {
        window.deferredPrompt = null
      }, 300)
    },

    handleConnection() {
      if (window.navigator.onLine) {
        if (this.$router.currentRoute.path == '/offline') {
          this.$router.push(baseStore.getters.lastKnownPage)
          toastStore.commit('success', {
            message: this.$t('messages.connectionRestoredToast'),
          })
        }
      } else if (this.$router.currentRoute.path != '/offline') {
        this.$router.push('/offline')
      }
    },

    getCurrentRouteAnimation() {
      return baseStore.getters.currentAnimation
    },

    installApp() {
      this.deferredPrompt.prompt()
      this.deferredPrompt.userChoice.then(choiceResult => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt')
        } else {
          console.log('User dismissed the A2HS prompt')
        }
        this.deferredPrompt = null
      })
    },

    determineLocales() {
      const localeFromStorage = window.localStorage.getItem('lang_locale')

      if (localeFromStorage) {
        this.$i18n.locale = localeFromStorage
      } else {
        if (['en', 'en-US', 'en-GB'].indexOf(this.detectLocale) != -1) {
          window.localStorage.setItem('lang_locale', 'en')
          this.$i18n.locale = 'en'
        } else if (['pl', 'pl-PL'].indexOf(this.detectLocale) != -1) {
          window.localStorage.setItem('lang_locale', 'pl')
          this.$i18n.locale = 'pl'
        }
      }
    },

    hideOnboardingHandler() {
      this.showOnboarding = false
    },

    showOnboardingAndModalsWhenLogin() {
      // Launch always
      this.showOnboarding = true // !localStorage.getItem('skip_onboarding') ? this.showOnboarding = true : this.showOnboarding = false;

      // App instalation
      if (!this.isStandalone) {
        ;(this.isChromeAndroid || this.isChromeDesktop || this.isFirefoxDesktop) &&
        !this.isAppInstalled()
          ? this.showAddAppToHomeScreenModal()
          : null

        // Launch for 'safari-ios' when user declared skip_install_app_prompt as true or when he enters first time (null).
        this.isSafariIos && JSON.parse(localStorage.getItem('skip_install_app_prompt')) != false
          ? this.showiOSAddToHomeScreenPromptModal()
          : null
      }

      // Push notification flow
      if (this.isChromeAndroid || this.isChromeDesktop || this.isFirefoxDesktop) {
        this.startFlowFCM()
      } else if (this.isSafariDesktop) {
        this.startFlowAPN() // mixin
      } else if (this.isSafariIos) {
        // iOSSafari - No solution for iOS Safari yet. ¯\_(ツ)_/¯
        this.registerUserActivityForSafariIos()
      }
    },

    startFlowFCM() {
      // First time interaction, diplaying custom modal, with button that displays NATIVE modal
      if (JSON.parse(localStorage.getItem('push_notifications_allowed')) == null) {
        this.$store.commit('modal/open', {
          cmp: NotificationPromptModalForChromeAndroidDesktop,
          animation: 'slide-down-menu',
        })

        // push_notifications_allowed == true or false -> we check FCM
      } else if (JSON.parse(localStorage.getItem('push_notifications_allowed')) != null) {
        // Kiedy user pozwoli na notyfikacje za pomoca ustawien natywnych nie mozemy na to nasluchiwać. Mozemy podczas logowania sprawdzić FCM czy nadal pokazać reminder.

        this.isFcmEnabled() // Tutaj nastąpi rejestracja urządzenia
        // TODO: Make this thenable
        // this.isFcmEnabled().then(data => {
        //   console.log('isFcmEnabled', data)
        // })
      }
    },

    registerUserActivityForSafariIos() {
      // Registered first time only when 'safari-ios' user fires push notification flow
      if (JSON.parse(localStorage.getItem('push_notifications_allowed')) == null) {
        this.updateUserActivity('safari-ios', 'push_notification_allowance', false)
      }
      localStorage.setItem('push_notifications_allowed', false)
    },

    isAppInstalled() {
      // INFO: Only way to determine if app was
      // previously installed is checking if there
      // is an empty `window.deferredPrompt`
      return !window.deferredPrompt
    },

    showAddAppToHomeScreenModal() {
      this.$store.commit('modal/open', {
        cmp: ShowAddAppToHomeScreenModal,
        animation: 'slide-down-menu',
      })
    },

    showiOSAddToHomeScreenPromptModal() {
      this.$store.commit('modal/open', {
        cmp: iOSAddToHomeScreenPromptModal,
        animation: 'slide-down-menu',
      })
    },

    checkVisibility() {
      // INFO: visibilitychange - Update data when app
      // is coming back form inactivity on mobile devices
      const isVisible = document.visibilityState == 'visible'
      const isDeliveryRoute = this.$route.path == '/delivery'
      const isLockersRoute = this.$route.path == '/lockers'
      isVisible && isDeliveryRoute ? mainApp.$emit('updateDeliveryRequests') : null
      isVisible && isLockersRoute ? mainApp.$emit('updateLockers') : null
    },
  },
  components: {
    ToastsContainer,
    NavigationBar,
    MenuContainer,
    ModalRoot,
    SignOutInfo,
    OnboardingScreen: () => import('@/vcs/_shared/onboarding-screen/cmp.vue'),
  },
}
</script>

<style lang="scss">
@import './assets/styles/main.scss';

#app {
  position: relative;
  height: 100vh;
  transition-timing-function: linear;
}
</style>
